// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared by ConfirmDialog and PromptDialog. ModalShell owns the box, the
   backdrop and the close X; everything here is the content inside it. */

.BGQF1ZxZ28ub1XFpAkFg {
    padding: 24px;
    font-family: var(--curio-font-family);
    color: var(--curio-text-primary);
    display: flex;
    flex-direction: column;
    min-height: 0;
}

.rTeBhSVT3ZHHDx6qdMla {
    /* Right padding clears ModalShell's absolutely positioned close X. */
    margin: 0 32px 12px 0;
    font-size: 1.125rem;
    font-weight: 600;
    color: var(--curio-text-primary);
}

._ejnx8SgyoeHQsvy4Dno {
    font-size: var(--curio-font-size-md);
    color: var(--curio-text-secondary);
    line-height: 1.5;
    overflow-y: auto;
    min-height: 0;
}

.lXKKiWmrYbWMAg501xrp {
    margin: 0 0 10px;
}

.lXKKiWmrYbWMAg501xrp:last-child {
    margin-bottom: 0;
}

.IauaGOEB122hGhhnoSDT {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 4px;
}

.bJ_5dHbX_kBNrndXBui_ {
    font-size: var(--curio-font-size-xs);
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-weight: 600;
    color: var(--curio-text-muted);
}

.B5rt6Ul02jU3NxLt3DtH {
    height: var(--curio-input-height);
    padding: 0 12px;
    border: 1px solid var(--curio-border-strong);
    border-radius: var(--curio-radius-md);
    background: var(--curio-card-bg);
    color: var(--curio-text-primary);
    font: inherit;
    font-size: var(--curio-font-size-md);
}

.B5rt6Ul02jU3NxLt3DtH:focus {
    outline: 2px solid var(--curio-role-update-fg);
    outline-offset: -1px;
}

.naJ2zVqk6p2fLcbqIFgz {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 20px;
}

.AB3V5alM98LVpGrENPIs {
    background: var(--curio-top-bar-bg);
    color: var(--curio-text-on-dark);
    border: none;
    padding: 0 20px;
    height: var(--curio-input-height);
    border-radius: var(--curio-radius-md);
    cursor: pointer;
    font: inherit;
    /* After \`font: inherit\`, which resets the weight when it comes later
       (#525). */
    font-weight: 600;
    font-size: var(--curio-font-size-lg);
}

.AB3V5alM98LVpGrENPIs:hover:not(:disabled) {
    background: #2c2d32;
}

.AB3V5alM98LVpGrENPIs:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

._sCUbOCWr88YWz33Plsi {
    /* White on --curio-danger (#ff6b6b) is 2.78:1; on the danger text colour
       it is 5.44:1 (#525). The token itself stays: it is also a text colour
       on a dark menu. */
    background: var(--curio-danger-text);
    color: #fff;
}

._sCUbOCWr88YWz33Plsi:hover:not(:disabled) {
    background: var(--curio-danger-strong);
}

.RSNMsVYu6EpJDTPHt3pd {
    background: var(--curio-card-bg);
    border: 1px solid var(--curio-border-strong);
    padding: 0 20px;
    height: var(--curio-input-height);
    border-radius: var(--curio-radius-md);
    cursor: pointer;
    font: inherit;
    font-weight: 500;
    font-size: var(--curio-font-size-lg);
    color: var(--curio-text-primary);
}

.RSNMsVYu6EpJDTPHt3pd:hover:not(:disabled) {
    background: var(--curio-page-bg);
}

.RSNMsVYu6EpJDTPHt3pd:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/ConfirmDialog.module.css"],"names":[],"mappings":"AAAA;wEACwE;;AAExE;IACI,aAAa;IACb,qCAAqC;IACrC,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,qEAAqE;IACrE,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;IAChB,8BAA8B;AAClC;;AAEA;IACI,iCAAiC;IACjC,eAAe;IACf,4CAA4C;IAC5C,qCAAqC;IACrC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,oCAAoC;AACxC;;AAEA;IACI,8CAA8C;IAC9C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;IAChC,YAAY;IACZ,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb;gBACY;IACZ,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;;wBAEoB;IACpB,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,4CAA4C;IAC5C,eAAe;IACf,iCAAiC;IACjC,qCAAqC;IACrC,eAAe;IACf,aAAa;IACb,gBAAgB;IAChB,oCAAoC;IACpC,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB","sourcesContent":["/* Shared by ConfirmDialog and PromptDialog. ModalShell owns the box, the\n   backdrop and the close X; everything here is the content inside it. */\n\n.dialog {\n    padding: 24px;\n    font-family: var(--curio-font-family);\n    color: var(--curio-text-primary);\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n}\n\n.title {\n    /* Right padding clears ModalShell's absolutely positioned close X. */\n    margin: 0 32px 12px 0;\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: var(--curio-text-primary);\n}\n\n.body {\n    font-size: var(--curio-font-size-md);\n    color: var(--curio-text-secondary);\n    line-height: 1.5;\n    overflow-y: auto;\n    min-height: 0;\n}\n\n.bodyText {\n    margin: 0 0 10px;\n}\n\n.bodyText:last-child {\n    margin-bottom: 0;\n}\n\n.field {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    margin-top: 4px;\n}\n\n.fieldLabel {\n    font-size: var(--curio-font-size-xs);\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    font-weight: 600;\n    color: var(--curio-text-muted);\n}\n\n.input {\n    height: var(--curio-input-height);\n    padding: 0 12px;\n    border: 1px solid var(--curio-border-strong);\n    border-radius: var(--curio-radius-md);\n    background: var(--curio-card-bg);\n    color: var(--curio-text-primary);\n    font: inherit;\n    font-size: var(--curio-font-size-md);\n}\n\n.input:focus {\n    outline: 2px solid var(--curio-role-update-fg);\n    outline-offset: -1px;\n}\n\n.footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 8px;\n    margin-top: 20px;\n}\n\n.actionButton {\n    background: var(--curio-top-bar-bg);\n    color: var(--curio-text-on-dark);\n    border: none;\n    padding: 0 20px;\n    height: var(--curio-input-height);\n    border-radius: var(--curio-radius-md);\n    cursor: pointer;\n    font: inherit;\n    /* After `font: inherit`, which resets the weight when it comes later\n       (#525). */\n    font-weight: 600;\n    font-size: var(--curio-font-size-lg);\n}\n\n.actionButton:hover:not(:disabled) {\n    background: #2c2d32;\n}\n\n.actionButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n\n.destructive {\n    /* White on --curio-danger (#ff6b6b) is 2.78:1; on the danger text colour\n       it is 5.44:1 (#525). The token itself stays: it is also a text colour\n       on a dark menu. */\n    background: var(--curio-danger-text);\n    color: #fff;\n}\n\n.destructive:hover:not(:disabled) {\n    background: var(--curio-danger-strong);\n}\n\n.ghostButton {\n    background: var(--curio-card-bg);\n    border: 1px solid var(--curio-border-strong);\n    padding: 0 20px;\n    height: var(--curio-input-height);\n    border-radius: var(--curio-radius-md);\n    cursor: pointer;\n    font: inherit;\n    font-weight: 500;\n    font-size: var(--curio-font-size-lg);\n    color: var(--curio-text-primary);\n}\n\n.ghostButton:hover:not(:disabled) {\n    background: var(--curio-page-bg);\n}\n\n.ghostButton:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialog": `BGQF1ZxZ28ub1XFpAkFg`,
	"title": `rTeBhSVT3ZHHDx6qdMla`,
	"body": `_ejnx8SgyoeHQsvy4Dno`,
	"bodyText": `lXKKiWmrYbWMAg501xrp`,
	"field": `IauaGOEB122hGhhnoSDT`,
	"fieldLabel": `bJ_5dHbX_kBNrndXBui_`,
	"input": `B5rt6Ul02jU3NxLt3DtH`,
	"footer": `naJ2zVqk6p2fLcbqIFgz`,
	"actionButton": `AB3V5alM98LVpGrENPIs`,
	"destructive": `_sCUbOCWr88YWz33Plsi`,
	"ghostButton": `RSNMsVYu6EpJDTPHt3pd`
};
export default ___CSS_LOADER_EXPORT___;
